import { Skeleton } from './skeleton';

type TSkeletonCardProps = {
  className?: string;
};

export function SkeletonCard({ className }: TSkeletonCardProps) {
  return <Skeleton className={`w-full h-full bg-skeleton rounded-[8px] ${className} `} />;
}
